import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import Text from '../Text';
import HelperText from './HelperText';

const StyledField = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const LabelBox = styled.div`
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
`;
const LabelTitle = styled.label``;
const LabelActionBox = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;
const HelperBox = styled.div`
  display: flex;
  justify-content: justify-content;
  margin-top: 4px;
`;
const HelperTextBox = styled.div`
  flex: 1;
`;
const HelperActionBox = styled.div`
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-end;
  margin-left: 4px;
  min-width: 50px;
`;

interface FieldProps extends PropsWithChildren {
  label?: React.ReactNode;
  labelAction?: React.ReactNode;
  hideLabelSpacing?: boolean;
  required?: boolean;
  helperText?: string;
  helperAction?: React.ReactNode;
  bottom?: {
    text?: string;
    action?: React.ReactNode;
  };
  id?: string;
  error?: boolean | string;
  className?: string;
}
const Field: React.FC<FieldProps> = ({
  label,
  labelAction,
  hideLabelSpacing = false,
  required,
  helperText,
  helperAction,
  id,
  error,
  children,
  className,
  bottom,
}) => {
  return (
    <StyledField className={className}>
      {!hideLabelSpacing && (
        <LabelBox>
          <LabelTitle htmlFor={id}>
            <Text inline typo="body5" color="gray50">
              {label}
            </Text>
            {required && (
              <div style={{ display: 'inline-flex', marginLeft: '2px' }}>
                <Text typo="body5" color="red50">
                  *
                </Text>
              </div>
            )}
          </LabelTitle>
          {labelAction && <LabelActionBox>{labelAction}</LabelActionBox>}
        </LabelBox>
      )}
      {children}
      {(helperText || (helperAction && !error)) && (
        <HelperBox>
          <HelperTextBox>
            <HelperText>{helperText}</HelperText>
          </HelperTextBox>
          <HelperActionBox>{helperAction}</HelperActionBox>
        </HelperBox>
      )}
      {bottom && (
        <HelperBox>
          <HelperTextBox>
            <HelperText>{bottom.text || ''}</HelperText>
          </HelperTextBox>
          <HelperActionBox>{bottom.action}</HelperActionBox>
        </HelperBox>
      )}
      {error && typeof error === 'string' && (
        <HelperBox>
          <HelperTextBox>
            <HelperText error={!!error}>{error}</HelperText>
          </HelperTextBox>
          {helperAction && <HelperActionBox>{helperAction}</HelperActionBox>}
        </HelperBox>
      )}
    </StyledField>
  );
};

export default Field;
